import { createSlice } from "@reduxjs/toolkit"

let roomSlice = createSlice({
    name: 'room-slice',
    initialState: {
        room: {
            roomId: null,
            creatorId: null,
            creatorName: 'X',
            otherPlayerId: null,
            otherPlayerName: 'O',
            board: [[' ', ' ', ' '], [' ', ' ', ' '], [' ', ' ', ' ']],
            gameState: '',
            creatorScore: 0,
            otherPlayerScore: 0,
            creatorTurn: true,
            otherPlayerTurn: false,
            active: true,
            winnerId: null,
        },
    },
    reducers: {
        updateRoom: (state, action) => {
            state.room.roomId = action.payload.roomId
            state.room.creatorId = action.payload.creatorId
            state.room.creatorName = action.payload.creatorName
            state.room.otherPlayerId = action.payload.otherPlayerId
            state.room.otherPlayerName = action.payload.otherPlayerName
            state.room.board = action.payload.board
            state.room.gameState = action.payload.gameState
            state.room.creatorScore = action.payload.creatorScore
            state.room.creatorTurn = action.payload.creatorTurn
            state.room.otherPlayerScore = action.payload.otherPlayerScore
            state.room.otherPlayerTurn = action.payload.otherPlayerTurn
            state.room.active = action.payload.active
            state.room.winnerId = action.payload.winnerId
        },
    },
})

export default roomSlice.reducer
export const { updateRoom } = roomSlice.actions